import React, { ReactNode, useState } from 'react';
import Collapse from '@mui/material/Collapse';
import MaterialIcon from 'commons/src/components/MaterialIcon';
import styles from './CollapsibleSection.module.scss';

type Props = {
    title: string;
    children: ReactNode;
    defaultExpanded?: boolean;
    collapsible?: boolean;
    headerRight?: ReactNode;
    collapsedContent?: ReactNode;
    testAttr?: string;
};

const CollapsibleSection = ({
    title,
    children,
    defaultExpanded = true,
    collapsible = true,
    headerRight,
    collapsedContent,
    testAttr,
}: Props): React.ReactElement => {
    const [expanded, setExpanded] = useState(defaultExpanded);

    const isExpanded = !collapsible || expanded;

    return (
        <div className={styles.card} data-testid={testAttr}>
            {collapsible ? (
                <button
                    type="button"
                    className={styles.header}
                    onClick={(): void => setExpanded(prev => !prev)}
                    aria-expanded={isExpanded}
                >
                    <h3 className={styles.header__title}>{title}</h3>
                    <div className={styles.header__right}>
                        {headerRight}
                        <MaterialIcon name={isExpanded ? 'expand_less' : 'expand_more'} />
                    </div>
                </button>
            ) : (
                <div className={styles.headerStatic}>
                    <h3 className={styles.header__title}>{title}</h3>
                    {headerRight && <div className={styles.header__right}>{headerRight}</div>}
                </div>
            )}
            {!isExpanded && collapsedContent && <div className={styles.collapsedContent}>{collapsedContent}</div>}
            <Collapse in={isExpanded} unmountOnExit={false}>
                <div className={styles.divider} />
                <div className={styles.content}>{children}</div>
            </Collapse>
        </div>
    );
};

export default CollapsibleSection;
